import React from "react";
import { Link } from "@tanstack/react-router";
import {
  ArrowRightOutlined,
  BarChartOutlined,
} from "@ant-design/icons";

type CTAAction = {
  label: string;
  to: string;
  icon: React.ReactNode;
  className: string;
};

const CTASection = () => {
  const isLoggedIn = Boolean(localStorage.getItem("AUTH_TOKEN"));

  const actions: CTAAction[] = isLoggedIn
    ? [
        {
          label: "Dashboard",
          to: "/dashboard",
          icon: <ArrowRightOutlined />,
          className:
            "bg-[#00B86B] text-white hover:bg-[#00995A]",
        },
        {
          label: "Reports",
          to: "/report",
          icon: <BarChartOutlined />,
          className:
            "border border-[#1D1F5D]/15 bg-white text-[#1D1F5D] hover:border-[#1D1F5D]/30 hover:bg-[#F7F8FC]",
        },
      ]
    : [
        {
          label: "Login to KGS Studio",
          to: "/login",
          icon: <ArrowRightOutlined />,
          className:
            "bg-[#00B86B] text-white hover:bg-[#00995A]",
        },
        {
          label: "Read Privacy Policy",
          to: "/privacy-policy",
          icon: <ArrowRightOutlined />,
          className:
            "border border-[#1D1F5D]/15 bg-white text-[#1D1F5D] hover:border-[#1D1F5D]/30 hover:bg-[#F7F8FC]",
        },
      ];

  return (
    <section className="bg-[#F7F8FC] px-5 py-12 sm:px-8 lg:px-10 lg:py-16">
      <div className="mx-auto max-w-[1440px]">
        <div className="relative overflow-hidden rounded-2xl border border-[#E2E5ED] bg-white px-6 py-8 shadow-[0_6px_24px_rgba(29,31,93,0.06)] sm:px-8 sm:py-9 lg:px-10">
          <div className="pointer-events-none absolute -right-20 -top-24 h-48 w-48 rounded-full bg-[#1D1F5D]/[0.035] blur-3xl" />

          <div className="pointer-events-none absolute -bottom-24 -left-20 h-48 w-48 rounded-full bg-[#00B86B]/[0.04] blur-3xl" />

          <div className="relative flex flex-col gap-7 lg:flex-row lg:items-center lg:justify-between lg:gap-10">

            <div className="max-w-3xl">
              <div className="flex items-center gap-2">
    

                <span className="text-xs font-semibold uppercase tracking-wider text-[#00A862]">
                  KGS Studio
                </span>
              </div>

              <h2 className="mt-2 text-xl font-bold tracking-tight text-[#172033] sm:text-2xl">
                KGS Studio — A product by Khan Global Studies
              </h2>

              <p className="mt-1.5 max-w-2xl text-sm leading-6 text-[#64748B] sm:text-[15px]">
                Authorized users can sign in to open the Studio dashboard,
                connect a YouTube channel and manage videos and live
                broadcasts. Questions about the product, privacy or the
                YouTube integration? Get in touch.
              </p>
            </div>


            <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
              {actions.map((action) => (
                <Link
                  key={action.label}
                  to={action.to}
                  className={`inline-flex items-center justify-center gap-2 rounded-lg px-5 py-3 text-sm font-semibold no-underline shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md ${action.className}`}
                >
                  {action.label}

                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;